export const soundKeys = {
  buttonClick: "button_click",
  damage: "damage",
  death: "death",
  shot: "shot",
  heartPickup: "heart_pickup",
  levelUp: "level_up"
} as const;

export type SoundKey = (typeof soundKeys)[keyof typeof soundKeys];

export type SoundDefinition = {
  key: SoundKey;
  path: string;
  volume: number;
};

export const soundManifest: SoundDefinition[] = [
  {
    key: soundKeys.buttonClick,
    path: "/audio/button_click.wav",
    volume: 0.28
  },
  {
    key: soundKeys.damage,
    path: "/audio/damage.wav",
    volume: 0.36
  },
  {
    key: soundKeys.death,
    path: "/audio/death.wav",
    volume: 0.42
  },
  {
    key: soundKeys.shot,
    path: "/audio/shot.wav",
    volume: 0.32
  },
  {
    key: soundKeys.heartPickup,
    path: "/audio/heart_pickup.wav",
    volume: 0.34
  },
  {
    key: soundKeys.levelUp,
    path: "/audio/level_up.wav",
    volume: 0.4
  }
];

export function isSoundKey(value: string): value is SoundKey {
  return Object.values(soundKeys).includes(value as SoundKey);
}